import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { X } from "lucide-react";
const SIZE_CLASSES = {
    sm: "max-w-md",
    md: "max-w-lg",
    lg: "max-w-3xl",
    xl: "max-w-6xl w-[95vw]",
};
export function Dialog({ open, onOpenChange, title, description, children, footer, className = "", size = "md", titleId, closeOnBackdrop = true, }) {
    const dialogRef = React.useRef(null);
    React.useEffect(() => {
        const dialog = dialogRef.current;
        if (!dialog)
            return;
        const handleClose = () => {
            if (open)
                onOpenChange(false);
        };
        dialog.addEventListener("close", handleClose);
        if (open && !dialog.open) {
            dialog.showModal();
        }
        else if (!open && dialog.open) {
            dialog.close();
        }
        return () => dialog.removeEventListener("close", handleClose);
    }, [open, onOpenChange]);
    const handleClose = React.useCallback(() => {
        onOpenChange(false);
    }, [onOpenChange]);
    return (_jsx("dialog", { ref: dialogRef, className: [
            "fixed inset-0 z-50 m-0 h-dvh max-h-none w-full max-w-none border-0 bg-transparent p-4 backdrop:bg-zinc-900/40",
            "open:flex open:items-center open:justify-center",
            className,
        ].join(" "), onCancel: (event) => {
            event.preventDefault();
            handleClose();
        }, onClick: (event) => {
            if (closeOnBackdrop && event.target === dialogRef.current) {
                handleClose();
            }
        }, children: _jsxs("div", { role: "document", className: [
                "flex max-h-[90vh] w-full flex-col overflow-hidden rounded-xl border border-zinc-200 bg-white shadow-xl",
                "ring-1 ring-black/[0.07]",
                SIZE_CLASSES[size],
            ].join(" "), onClick: (event) => event.stopPropagation(), children: [(title || description) && (_jsxs("header", { className: "flex flex-none items-start justify-between border-b border-zinc-100 px-5 py-4", children: [_jsxs("div", { className: "min-w-0 pr-4", children: [title ? (_jsx("h2", { id: titleId, className: "text-base font-semibold text-zinc-900", children: title })) : null, description ? _jsx("p", { className: "mt-1 text-sm text-zinc-500", children: description }) : null] }), _jsx("button", { type: "button", "aria-label": "Close dialog", onClick: handleClose, className: "flex h-8 w-8 flex-none items-center justify-center rounded-md text-zinc-400 transition-colors hover:bg-zinc-100 hover:text-zinc-900", children: _jsx(X, { className: "h-5 w-5", "aria-hidden": true }) })] })), children ? (_jsx("div", { className: "flex-1 overflow-y-auto px-5 py-4 text-sm text-zinc-700", children: children })) : null, footer ? (_jsx("footer", { className: "flex flex-none flex-wrap items-center justify-end gap-2 border-t border-zinc-100 px-5 py-4", children: footer })) : null] }) }));
}
